import { useMutation } from "react-query";
import { useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { postRegisterUser } from "./postRegisterUser";
import { TData, TRegisterUserBody } from "./types";
import { translations } from "../../../i18n/translations";
import { setAccessToken } from "../../../utils/setAccessToken";
import { setUserRevenueCatId } from "../../../utils/User/setUserRevenueCatId";

export const useRegisterUser = () => {
  const toast = useToast();
  return useMutation<TData, unknown, TRegisterUserBody>(
    (payload) => postRegisterUser(payload),
    {
      onError: (err) => {
        console.log(err);
        toast({
          title: "Error",
          description:
            (err as Error)?.message ||
            t<string>(translations.errors.register_user_error),
          status: "error",
          position: "top-right",
        });
      },
      onSuccess: (data) => {
        setAccessToken(data.accessToken);
        setUserRevenueCatId(data.userData?.revenueCatUserId as string);
      },
    }
  );
};
